<template>
  <div>
    <froala
      v-model="content"
      :config="editorOption"
      @input="onEditorBlur"
    />
  </div>
</template>

<script>
import { API_URL } from '@/config'
import getHeaders from '@/extensions/headers'

import Vue from 'vue'
import VueFroala from 'vue-froala-wysiwyg'

import 'froala-editor/js/froala_editor.pkgd.min'
import 'froala-editor/css/froala_editor.pkgd.min.css'
import 'froala-editor/css/froala_style.min.css'
import jquery from 'jquery'
window.$ = jquery

Vue.use(VueFroala)

jquery.FroalaEditor.DefineIcon('infoBlock', {
  NAME: 'info-circle'
})
jquery.FroalaEditor.RegisterCommand('infoBlock', {
  title: 'Info block',
  focus: true,
  undo: true,
  refreshAfterCallback: true,
  callback: function () {
    this.html.insert('<div class="content-info-block">' + this.html.getSelected() + '</div>')
  }
})

export default {
  name: 'FieldRichText',
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      content: this.value,
      editorOption: {
        imageUploadRemoteUrls: false,
        imageUploadURL: API_URL + 'sites/' + this.$route.params.siteId + '/images',
        imageManagerLoadURL: API_URL + 'sites/' + this.$route.params.siteId + '/images',
        imageManagerDeleteURL: API_URL + 'images',
        imageManagerDeleteMethod: 'DELETE',
        requestHeaders: getHeaders(),
        imageUploadParam: 'file',
        imageInsertButtons: [
          'imageByURL',
          'imageManager',
          'imageUpload'
        ],
        imageDefaultWidth: 0,
        events: {
          'froalaEditor.initialized': () => {
            // jquery('.fr-wrapper').animate({ scrollTop: 32 }, 0)
          }
        },
        toolbarSticky: false,
        heightMax: 500,
        toolbarButtons: [
          'fullscreen',
          'bold',
          'italic',
          'underline',
          'strikeThrough',
          'subscript',
          'superscript',
          '|',
          'fontFamily',
          'fontSize',
          // 'color',
          // 'inlineStyle',
          'paragraphStyle',
          '|',
          'paragraphFormat',
          'align',
          'formatOL',
          'formatUL',
          'outdent',
          'indent',
          'quote',
          '-',
          'insertLink',
          'insertImage',
          'insertVideo',
          // 'embedly',
          // 'insertFile',
          'insertTable',
          'infoBlock',
          '|',
          'emoticons',
          'specialCharacters',
          'insertHR',
          'selectAll',
          'clearFormatting',
          '|',
          // 'print',
          'spellChecker',
          'help',
          'html',
          '|',
          'undo',
          'redo'
        ]
      }
    }
  },
  watch: {
    value (val) {
      this.content = val
    }
  },
  methods: {
    onEditorBlur () {
      this.$emit('input', this.content)
    }
  }
}
</script>

<style>
  .fr-box {
    margin-bottom: 20px;
  }

  .fr-delete-img {
    display: none !important;
  }

  .fr-insert-img {
    transform: translateY(-50%) translateX(-50%) !important;
  }
</style>
